// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-box-icon {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: var(--icon-height, 2rem);
  width: var(--icon-width, 2rem);
}

ion-icon {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cdn-icon/cdn-icon.component.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;AACJ;;AAIA;EACI,aAAA;AADJ","sourcesContent":[".image-box-icon {\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    height: var(--icon-height, 2rem);\n    width: var(--icon-width, 2rem);\n    // filter: brightness(10);\n    // -webkit-filter: brightness(10);\n}\n\nion-icon {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
